import React, { useEffect } from "react";
import Header from "../Landing/components/Header";
import Footer from "../Landing/components/Footer";
import SocialNetworks from "../Landing/components/SocialNetworks";
import MainBannerSlider from "../Landing/components/MainBannerSlider";

const LandingTemplate = (props) => {
  const { children, wrapClass, mainSlider } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-pages">
      <Header />
      {mainSlider && <MainBannerSlider />}
      <div className={`main-wrap ${wrapClass}`}>{children}</div>
      {/*<SocialNetworks />*/}
      <Footer />
    </div>
  );
};

export default LandingTemplate;
